
import * as _ from 'lodash-es'
import { defineComponent, PropType } from 'vue'
import GlossaryChapter from './GlossaryChapter.vue'
import { getDiagramUrl } from '@helpers/CommunityHelper'
import { getThumbnailUrl } from '@helpers/DiagramHelper'
import { Chapter } from '@interfaces/GlossaryTypes'
import { Block } from '@/domain/interfaces/BlockTypes'

export default defineComponent({
  name: 'GlossaryHomepage',
  components: {
    GlossaryChapter,
  },
  props: {
    block: {
      type: Object as PropType<Block>,
      required: true,
    },
  },
  data() {
    return {
      expandedChapters: ['chapter-A'] as string[],
    }
  },
  mounted() {
    this.$nextTick(() => {
      const chapterIElement = document.getElementById('chapter-I')
      if (chapterIElement) {
        const elementWithClass: HTMLElement | null =
          chapterIElement.querySelector('.glossary-chapter__first-letter')
        if (elementWithClass) {
          elementWithClass.style.paddingRight = '12px'
        }
      }
    })
  },
  methods: {
    chaptersFirstLetter() {
      if (!this.block.chapters || this.block.chapters.length === 0) {
        return []
      }

      const chaptersObject: { [key: string]: Chapter } =
        this.block.chapters[0].chapter
      const uniqueFirstLetters = new Set()
      Object.values(chaptersObject).forEach((chapter) => {
        if (chapter.published) {
          const firstLetter = chapter.title.charAt(0).toUpperCase()
          uniqueFirstLetters.add(firstLetter)
        }
      })
      return Array.from(uniqueFirstLetters)
    },

    allChapters(): Chapter[] {
      const glossaryDiagrams = this.$store.state.diagrams.glossary
      let chapters = _.map(this.block.chapters[0].chapter, (chapter) => {
        chapter.letter = chapter.title.trim().charAt(0).toUpperCase()

        if (chapter.diagramFuid) {
          const matchingDiagram = glossaryDiagrams.find(
            (diagram: { fuid: string }) => diagram.fuid === chapter.diagramFuid
          )

          if (matchingDiagram) {
            chapter.diagramName = matchingDiagram.name
            chapter.diagramLink =
              this.$config.nuxtBaseURL + getDiagramUrl(matchingDiagram)
            chapter.diagramThumbnailUrl =
              this.$config.apiBaseURL + getThumbnailUrl(matchingDiagram)
          }
        }
        return chapter as Chapter
      })
      const idMap = {}
      chapters.sort((a, b) => a.title.localeCompare(b.title))
      chapters = chapters.filter((chapter) => chapter.published)

      return chapters.map((chpt) => {
        if (!Object.prototype.hasOwnProperty.call(idMap, chpt.letter)) {
          idMap[chpt.letter] = 1
          chpt.id = 1
          return chpt
        } else {
          chpt.id = null
          return chpt
        }
      })
    },

    scrollToSection(sectionId: string) {
      const targetSection = document.getElementById(sectionId)
      if (targetSection) {
        const firstChapterOfSection = this.allChapters()?.find(
            (chapter) =>
                chapter?.letter === sectionId.charAt(sectionId.length - 1) &&
                chapter?.id === 1
        )
        if (firstChapterOfSection) {
          this.expandedChapters = [`chapter-${firstChapterOfSection.letter}`]
        }
        this.$nextTick(() => {
          const offset = 180
          window.scrollTo({
            top: targetSection.offsetTop - offset,
            behavior: 'smooth',
          })
        })
      }
    },
  },
})
